module.exports = __webpack_public_path__ + "img/ds-17.1fc5fe46.gif";